import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute('/blocks/$schema')({
  validateSearch: z.object({ block: z.string().optional().catch(undefined), delta: z.number().int().optional().catch(undefined), excel: z.boolean().optional().catch(undefined) }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/data', search: { view: search.excel ? 'tokens' : 'datasets', dataset: search.block, delta: search.delta }, replace: true })
  },
})
